import { useTranslation } from 'react-i18next'

export const usePaymentStatus = () => {
	const { t } = useTranslation()

	return [
		{
			value: 'init',
			label: t('Init')
		},
		{
			value: 'success',
			label: t('Success')
		},
		{
			value: 'pending',
			label: t('Pending')
		},
		{
			value: 'error',
			label: t('Error')
		},
		{
			value: 'canceled',
			label: t('Cancelled')
		},
		{
			value: 'in_store',
			label: t('In store')
		}
	]
}
